export const BRAINTREE_ERROR = 'BraintreeError'
